import WPAPI from 'wpapi';

import EditorialConfig from '@/editorial-config';

const wpApi = (options?: {} | null) => {
    return new WPAPI({
        ...(options || {}),
        endpoint: EditorialConfig.wpApiUrl,
    }).setHeaders({
        'Build-Token': process.env.NEXT_PUBLIC_BUILD_TOKEN ?? '',
        'Vercel-Build': process.env.VERCEL_BUILD ? '1' : '0',
        'User-Agent': 'blockworks-editorial/1.0',
    });
};

export default wpApi;
